import { PTAC_UNIT_GRID_SQUARES } from '@alpinehomeair/common';
import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { GridSpaceDataType, PositionType } from 'data/types';

export const PTAC_UNIT_DROP_REACH_FT = PTAC_UNIT_GRID_SQUARES;

function distanceToRoomPx(
  point: PositionType,
  room: GridSpaceDataType
): number {
  const { x, y, width, height } = room.position;
  const clampedX = Math.max(x, Math.min(point.x, x + width));
  const clampedY = Math.max(y, Math.min(point.y, y + height));
  return Math.hypot(point.x - clampedX, point.y - clampedY);
}

export function ptacRoomForDrop(
  unitPosition: PositionType,
  levelSpaces: GridSpaceDataType[]
): GridSpaceDataType | null {
  const centerPx = {
    x: (unitPosition.x + PTAC_UNIT_GRID_SQUARES / 2) * STRUCTURE_GRID_SIZE,
    y: (unitPosition.y + PTAC_UNIT_GRID_SQUARES / 2) * STRUCTURE_GRID_SIZE
  };
  const reachPx = PTAC_UNIT_DROP_REACH_FT * STRUCTURE_GRID_SIZE;
  return levelSpaces.reduce<GridSpaceDataType | null>((best, room) => {
    const distance = distanceToRoomPx(centerPx, room);
    if (distance > reachPx) return best;
    return best === null || distance < distanceToRoomPx(centerPx, best)
      ? room
      : best;
  }, null);
}
